import type { BariPreNurseSpecialistMedScreeningReportDataV1 } from '@common/validation/customControls/bariPre/bariPreNurseSpecialistMedScreeningReport/v1/bariPreNurseSpecialistMedScreeningReportDataV1';

export const initialDataV1: BariPreNurseSpecialistMedScreeningReportDataV1 = {
    GERD: null,
    HDL_cholesterol: null,
    HIV_AIDS: null,
    LDL_cholesterol: null,
    OSAS: null,
    abdominaal: null,
    allergieen: null,
    ander_onderzoek: null,
    ander_onderzoek_toelichting: null,
    bindweefselziekte: null,
    buikklachten: null,
    buikklachten_toelichting: null,
    cardiologisch_onderzoek: null,
    cardiologisch_onderzoek_toelichting: null,
    cerebrovasculaire_aandoening: null,
    chronische_longziekte: null,
    congestief_hartfalen: null,
    consistentie_ontlasting: null,
    consistentie_ontlasting_overig: null,
    consult_MDL_arts_gehad: null,
    consult_MDL_arts_toelichting: null,
    consult_internist_gehad: null,
    consult_internist_toelichting: null,
    contra_indicatie: null,
    contra_indicatie_toelichting: null,
    dagbehandeling: null,
    dagbehandeling_toelichting: null,
    dementie: null,
    diabetes_mellitus: null,
    diabetes_mellitus_details: null,
    diabetes_mellitus_diagnose: null,
    duur_overgewicht_in_jaren: null,
    dyslipidemie: null,
    eerdere_operaties: null,
    eerdere_operaties_toelichting: null,
    extremiteiten: null,
    gastrointestinaal_ulcuslijden: null,
    gewrichtsklachten: null,
    hart_en_vaatziekten: null,
    hartfalen: null,
    hba1c: null,
    helicobacter_pylori_behandeld_met_antibiotica: null,
    helicobacter_pylori_behandeld_met_antibiotica_type: null,
    helicobacter_pylori_onderzoek_datum: null,
    helicobacter_pylori_onderzoek_gehad: null,
    helicobacter_pylori_sprake_van: null,
    hypertensie: null,
    hypertensie_diagnose: null,
    klachten_van_reflux: null,
    leverziekte: null,
    littekens_abdomen: null,
    littekens_toelichting: null,
    longfunctieonderzoek: null,
    longfunctieonderzoek_toelichting: null,
    maligniteit: null,
    medicatie: null,
    medicatie_toelichting: null,
    medische_voorgeschiedenis: null,
    motivatie_behandeling: null,
    myocardinfarct: null,
    nierziekte: null,
    onderzoek_interne_geneeskunde: null,
    onderzoek_interne_geneeskunde_toelichting: null,
    ontlasting_frequentie_per_week: null,
    ontlastingspatroon: null,
    overgewicht: null,
    overgewicht_bij_wie_options: {
        overgewicht_broer_zus: null,
        overgewicht_moeder: null,
        overgewicht_vader: null,
    },
    para_hemiplegie: null,
    patient_is_mobiel: null,
    patient_is_verwezen_door: null,
    perifeer_vaatlijden_aneurysma_aorta: null,
    slaaponderzoek: null,
    slaaponderzoek_toelichting: null,
    smetten: null,
    toelichting_speciele_anamnese: null,
    triglyceriden: null,
    trombose: null,
    verhoogd_risico_DVT_of_PE: null,
    viscerale_obesitas: null,
    vitaminedeficienties: null,
    vitaminedeficienties_toelichting: null,
    wens_voor_type_operatie: null,
    wens_voor_type_operatie_anders_toelichting: null,
};
